import {
	createContext,
	type ParentComponent,
	useContext,
} from "solid-js";
import type { ArtifactKindDefinition } from "@/client";
import type { ArtifactKindDisplay } from "./artifactKindCatalog";
import { useArtifactKindCatalog } from "./useArtifactKindCatalog";

type ArtifactKindsContextValue = {
	kindCatalog: () => Record<string, ArtifactKindDefinition>;
	displayKind: (
		kind: string | undefined,
		options?: { isCsvFile?: boolean },
	) => ArtifactKindDisplay;
};

const ArtifactKindsContext = createContext<ArtifactKindsContextValue>();

export const ArtifactKindsProvider: ParentComponent = (props) => {
	const { kindCatalog, displayKind } = useArtifactKindCatalog();
	return (
		<ArtifactKindsContext.Provider value={{ kindCatalog, displayKind }}>
			{props.children}
		</ArtifactKindsContext.Provider>
	);
};

export function useArtifactKindsContext(): ArtifactKindsContextValue {
	const ctx = useContext(ArtifactKindsContext);
	if (!ctx) {
		throw new Error(
			"Answer kind display requires ArtifactKindsProvider or ArtifactsListProvider",
		);
	}
	return ctx;
}
